module.exports = __webpack_public_path__ + "static/media/carousel2.82f7ccb8.gif";